export const API_INTERNAL_ENDPOINT = 'internal/contact-form'
